import componentLocator from './component_locator';
import useServiceWorker from './configuration.js.erb';

const PAGES = 'pages-v0'; // match this with service_worker.js
const BACKUP = 'backup-v0'; // match this with service_worker.js
const POST_REQUESTS = 'post-v0';

// TODO for the future:
// Pre-load everything in install step.
// What to do with modals?
// Your Research Suggestions

var handlingPostRequests = false; // Effectively a mutex.
class OfflineHandler {
    initialize() {
        if (!useServiceWorker) return;

        $(window).on('offline', () => {
            this.toggleOfflineClass(false);
            if (componentLocator.f.onOffline) componentLocator.f.onOffline();
        });
        $(window).on('online', () => {
            this.toggleOfflineClass(true);
            this.handlePostRequests();
            if (componentLocator.f.onOnline) componentLocator.f.onOnline();
        });
        this.toggleOfflineClass(navigator.onLine)
        $('body').toggleClass('online', navigator.onLine);
        $('body').toggleClass('offline', !navigator.onLine);
        componentLocator.waitUntilLoaded().then(() => this.handlePostRequests());

        // We cache the page's components if they aren't already stored.
        if (window.caches) this.cacheComponents();
    }

    toggleOfflineClass(isOnline) {
        $('body').toggleClass('online', isOnline);
        $('body').toggleClass('offline', !isOnline);
    }

    async cacheComponents() {
        const path = `${location.protocol}//${location.host}${location.pathname}`
        const compPath = `${location.protocol}//${location.host}/components${location.pathname}`

        if (await caches.match(compPath)) return;
        if (!(await caches.match(path))) return;

        const cache = await caches.open(PAGES);
        await cache.put(compPath, new Response(JSON.stringify(window.components)));
    }

    async getCachedPages() {
        return (await this._listCachedPages(PAGES))
            .concat(await this._listCachedPages(BACKUP));
    }

    async _listCachedPages(cache_name) {
        const cache = await caches.open(cache_name);
        const keys = await cache.keys();
        return keys.map(key => typeof(key) === 'string' ? key : key.url)
            .filter(key => key.includes('/components/'))
            .map(key => {
                let parts = key.split('/');
                return parts[parts.length - 1];
            });
    }

    async clearCaches() { // Mainly helpful for debugging. Clears *all* caches.
        const cacheNames = await caches.keys();
        return Promise.all(cacheNames.map(async cacheName => {
            const cache = await caches.open(cacheName);
            const cacheKeys = await cache.keys();
            return Promise.all(cacheKeys.map(async key => cache.delete(key)));
        }));
    }

    async handlePostRequests() {
        if (handlingPostRequests) return;

        handlingPostRequests = true;
        let cache = await caches.open(POST_REQUESTS);
        let keys = await cache.keys();
        await Promise.all(keys.map(async key => {
            let response = await cache.match(key);
            let {headers, body} = await response.json();
            await this.deferrablePost(key.url, body, headers);
            await cache.delete(key);
        }));
        handlingPostRequests = false;
    }

    // Sends a post request if online, otherwise defers it. Type must be JSON.
    // Returns a promise, which yields true if the post was deferred, else false.
    // Discards the response body (as this cannot be effectively deferred).
    deferrablePost(uri, body, headers={}) {
        return new Promise(resolve => {
            if (navigator.onLine || !('serviceWorker' in navigator)) {
                $.ajax({
                    type: "POST",
                    url: uri,
                    data: JSON.stringify(body),
                    dataType: 'json',
                    contentType: 'application/json',
                    headers: headers
                }).always(() => resolve(false));
            } else {
                caches.open(POST_REQUESTS).then(cache => 
                    cache.put(uri, new Response(JSON.stringify({headers: headers, body: body})))
                ).then(() => resolve(true));
            }
        });

    }
}

const handler = new OfflineHandler();
// Remove this once development is completed.
$(document).ready(() => handler && handler.initialize());
window.clearCaches = handler.clearCaches;

export default handler;
export let deferrablePost = handler.deferrablePost;